var _g, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 217,
    viewBox: "0 0 160 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.756 44.4035C109.509 35.5067 102.068 28.0692 93.1716 27.8192C83.7466 27.557 75.8938 34.9845 75.6313 44.4095C75.6269 44.5679 75.6248 44.7264 75.6248 44.8848C75.6248 47.1285 77.4435 48.9473 79.6872 48.9473C81.931 48.9473 83.7497 47.1285 83.7497 44.8848C83.7513 39.9436 87.7581 35.9392 92.6994 35.9408C92.7819 35.9408 92.8641 35.942 92.9466 35.9442C97.8859 36.0845 101.776 40.2026 101.636 45.1417C101.541 48.4617 99.6156 51.456 96.6341 52.9191C91.7419 55.2779 88.6309 60.2285 88.6278 65.6597V69.8753C88.6278 72.1191 90.4466 73.9378 92.6903 73.9378C94.934 73.9378 96.7528 72.1191 96.7528 69.8753V65.6566C96.7684 63.3241 98.1175 61.2066 100.225 60.2066C106.21 57.2466 109.93 51.0785 109.756 44.4035Z",
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6909 79.2461C90.4472 79.2461 88.6284 81.0648 88.6284 83.3086V84.6929C88.6284 86.9367 90.4472 88.7554 92.6909 88.7554C94.9346 88.7554 96.7534 86.9367 96.7534 84.6929V83.3055C96.7515 81.063 94.9334 79.2461 92.6909 79.2461Z",
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.8 21.5977H10.4C6.86538 21.5977 4 24.463 4 27.9977V117.747C4 119.444 4.67428 121.072 5.87452 122.272L33.7255 150.123C34.9257 151.323 36.5536 151.998 38.251 151.998H95.2C98.7346 151.998 101.6 149.132 101.6 145.598V127.598",
    stroke: "#6D6D6D",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeDasharray: "19.2 19.2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.4002,
    cy: 58.0008,
    r: 53.2,
    fill: "#96D0B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5 36.6406L114 80.1406",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5 36.6406L114 80.1406",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 36.6406L70.5 80.1406",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 36.6406L70.5 80.1406",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.672 121.469C151.234 123.031 153.766 123.031 155.328 121.469C156.891 119.907 156.891 117.374 155.328 115.812L149.672 121.469ZM127.672 99.4691L149.672 121.469L155.328 115.812L133.328 93.8122L127.672 99.4691Z",
    fill: "#96D0B2"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.16,
    cx: 80,
    cy: 212.5,
    rx: 40.5,
    ry: 4.5,
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.0802a8827d330b9380d70ada14ea3746.svg";
export { ForwardRef as ReactComponent };